import React from "react";

import { TableBody } from "../../UI/TableBody";

import { UserSearchResultsTableBodyRow } from "./UserSearchResultsTableBodyRow";

interface IProps {
  isImportDate?: boolean;
  users: Record<string, any>[];
  isGlobalSearch: boolean;
}

export const UserSearchResultsTableBody: React.FC<IProps> = (props) => (
  <TableBody>
    {props.users.map((user) => (
      <UserSearchResultsTableBodyRow
        user={user}
        key={user.id}
        isGlobalSearch={props.isGlobalSearch}
        isImportDate={props.isImportDate}
      />
    ))}
  </TableBody>
);
